import React from "react";

const IconTwitter: React.FC = () => {
  return <img src="/tw.png" width={20} height={20}></img>;
};

export default IconTwitter;
